export default __webpack_public_path__ + "assets/favicon.d6e3d09a500481110b2b4bc08bf3a50b.png";